// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"YV-z","inlineTitle":"ZV-z","sponsoredAdsWrapper":"_V-z","marketplaceRecosWrapper":"aW-z"};